import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const options = {
  timing: 200,
}

class Modal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
      showContent: false,
      leave: false,
    }

    this.options = options
    this.handleCloseModal = this.handleCloseModal.bind(this)
  }

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    className: PropTypes.string,
    closeModal: PropTypes.func,
    size: PropTypes.string,
    showCloseModal: PropTypes.bool,
    onCloseModal: PropTypes.func,
    under:PropTypes.bool,
    height: PropTypes.string,
  }

  componentDidMount() {
    document.body.classList.add('no-scroll')

    setTimeout(() => {
      this.setState({ show: true, showContent: true })
    }, this.options.timing)
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
  }

  handleCloseModal() {
    const { closeModal, onCloseModal } = this.props

    if(onCloseModal) {
      onCloseModal()
      return
    }

    this.setState({ leave: true, show: false, showContent: false })

    if (closeModal) {
      setTimeout(() => closeModal(), this.options.timing)
    }
  }

  render() {
    const { children, size, className, showCloseModal = true, under = false } = this.props
    const { show, showContent, leave } = this.state

    const componentClass = classNames(
      'modal',
      'modal-enter',
      {
        'modal-show': show,
        'modal-leave': leave,
      },
      className
    )

    const contentClass = classNames('modal-content', 'modal-content-enter', {
      'modal-content-show': showContent,
      'modal-content-leave': leave,
      [`modal-content-${size}`]: size,
    })

    return (
      <div style={{zIndex: under ? 99 : 9999}} className={componentClass}>
        <div  className={contentClass} style={{ height: this.props.height }}>
          <div className='modal-body'>
            <div className='container-fluid auto-height'>{children}</div>
          </div>

          {showCloseModal && (
            <i
              className='modal-close glyph glyph-x'
              onClick={this.handleCloseModal}
            />
          )}
        </div>
      </div>
    )
  }
}

export default Modal
